// extracted by mini-css-extract-plugin
module.exports = {"m-b-1":"Spaces_m-b-1__3Sxej","text":"ForgotPassword_text__1sx8h Spaces_m-b-1__3Sxej"};